import React from 'react';

import './scholar.css';

const Component = (props) => {
    const { scholar } = props;

    const setBroadArea = (broadArea) => {
        if (broadArea && broadArea.length > 0)
            return (
                <p>
                    <span className="scholar-block">Broad Area: </span>
                    {broadArea}
                </p>
            );

        return '';
    };

    const setThesis = (thesis) => {
        if (thesis && thesis.title.length > 0)
            return (
                <p>
                    <span className="scholar-block">Thesis: </span>
                    <a target="blank" href={thesis.link}>
                        {thesis.title}
                    </a>
                </p>
            );

        return '';
    };

    const setStatus = (status) => {
        if (status && status.length > 0)
            return (
                <p>
                    <span className="scholar-block">Status: </span>
                    {status}
                </p>
            );

        return '';
    };

    return (
        <div className="row">
            <div className="col-lg-1 col-12 scholar-profile-container">
                <img
                    className="scholar-profile"
                    alt="profile"
                    src={`${process.env.PUBLIC_URL}/_static/phd-scholars/${scholar.image}`}
                />
            </div>
            <div className="col-lg-11 col-12 scholar-content">
                <p className="scholar-name">
                    {scholar.name}{' '}
                    <span className="scholar-note">{scholar.note ? `(${scholar.note})` : ''}</span>
                </p>
                {!scholar.thesis.title ? setBroadArea(scholar.broadArea) : ''}
                {setThesis(scholar.thesis)}
                {setStatus(scholar.status)}
            </div>
        </div>
    );
};

export default Component;
